import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ConsentPlayfulPage } from "../ConsentPlayfulPage/ConsentPlayfulPage";
import { ConstentTraditionalPage } from "../ConstentTraditionalPage/ConstentTraditionalPage";
import { sendAnalyticsPageViewEvent } from "../../utils/adobeDataLayerUtils";
import { ENV } from "../../env";
import { useAcid } from "../../hooks/useAcid";
import { useAccessToken } from "../../hooks/useAccessToken";
import { SignInDialogUi } from "../../components";
import { useConsent } from "../../hooks/useConsent";

export const ConsentPageChoose = () => {
  const location = useLocation();
  const [isPlayful, setIsPlayful] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const signInRedirect = searchParams.get("signInRedirect");

    if (signInRedirect) {
      const consentChoice = searchParams.get("consent");
      handleConsentChoice(consentChoice);
      return;
    }

    const variantParam = searchParams.get("variant");
    let isPlayfulValue = false;

    if (variantParam === "playful") {
      isPlayfulValue = true;
    } else if (variantParam === "traditional") {
      isPlayfulValue = false;
    } else {
      // Default A/B testing behavior
      const random = Math.random();
      isPlayfulValue = random <= ENV.FEATURE_FLAGS.consentPlayfulProbability;
    }

    setIsPlayful(isPlayfulValue);

    const consentPageViewName = isPlayfulValue
      ? "Consent Playful Page"
      : "Consent Traditional Page";
    sendAnalyticsPageViewEvent(consentPageViewName, 'Passions-Consent', isPlayfulValue ? 'playful' : 'traditional');
  }, [location.search]);

  const { acid } = useAcid();
  const { accessToken } = useAccessToken();
  const [showSignInDialog, setShowSignInDialog] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("/consent/thank-you");
  const { save, loading } = useConsent();
  const navigate = useNavigate();

  const handleConsentChoice = useCallback(
    async (consentValue) => {
      console.log("User consent choice:", consentValue);
      if (!acid || !accessToken) {
        setRedirectUrl(`/consent?consent=${consentValue}&signInRedirect=true`);
        setShowSignInDialog(true);
        return;
      }

      let savedSuccessfully = false;

      try {
        // Save consent choice via API
        await save(acid, consentValue);
        savedSuccessfully = true;
      } catch (error) {
        console.error("Error saving consent:", error);
        savedSuccessfully = false;
        // Still navigate to thank you page even if API call fails
      }

      // Navigate to thank you page regardless of API success/failure
      navigate(
        `/consent/thank-you?consent=${consentValue}&saveSuccess=${savedSuccessfully}`,
      );
    },
    [acid, save, navigate],
  );

  const onCloseDialog = useCallback(
    () => setShowSignInDialog(false),
    [setShowSignInDialog],
  );

  const onSubmitDialog = useCallback(() => {
    onCloseDialog();
    // After successful login, the user will be redirected back
    // and can try the opt-in process again
  }, [onCloseDialog]);

  return (
    <>
      {isPlayful ? (
        <ConsentPlayfulPage
          handleConsentChoice={handleConsentChoice}
          loading={loading}
        />
      ) : (
        <ConstentTraditionalPage
          handleConsentChoice={handleConsentChoice}
          loading={loading}
        />
      )}
      {showSignInDialog && (
        <SignInDialogUi
          onClose={onCloseDialog}
          onSubmit={onSubmitDialog}
          cid="consent-playful"
          redirectUrl={redirectUrl}
        />
      )}
    </>
  );
};
